/**
 * Displays BootStrap 5 Modal Block.
 */
export default class ModalBlock {
  constructor(bootstrapInstance) {
    this.bootstrap = bootstrapInstance;
    document.addEventListener("DOMContentLoaded", () => this.init());
  }

  init() {
    const modalBlocks = document.querySelectorAll(".modal-block");
    if (modalBlocks.length > 0) {
      this.setupModal(modalBlocks[0]);
    }
  }

  setupModal(modalBlock) {
    const modal = modalBlock.querySelector(".modal");
    const modalID = modalBlock.getAttribute("id");
    const modalCookieName = `modal-${modalID}`;
    const timeDelay = parseInt(modalBlock.dataset.timeDelay, 10);
    const displayOnce = modalBlock.dataset.displayOnce === "true";

    if (!displayOnce || !document.cookie.includes(`${modalCookieName}=1`)) {
      const showModal = () => {
        const bootstrapModal = new this.bootstrap.Modal(modal);
        bootstrapModal.show();
      };

      if (!isNaN(timeDelay) && timeDelay > 0) {
        setTimeout(showModal, timeDelay);
      } else {
        showModal();
      }

      if (displayOnce) {
        document.cookie = `${modalCookieName}=1; path=/; max-age=31536000`; // 1 year
      }
    }
  }
}
